import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { getFileUrl } from '../utils/fileUtils';
import './CasaEncuentroCarousel.css';

const CasaEncuentroCarousel = ({ urls = [], alt = '', placeholder = '/images/placeholder-casa.svg' }) => {
  const [idx, setIdx] = useState(0);
  const n = urls.length;
  const urlsKey = urls.join('|');

  useEffect(() => {
    setIdx(0);
  }, [urlsKey]);

  const goTo = (next) => setIdx((next + n) % n);

  const handleImgError = (e) => {
    e.target.src = placeholder;
  };

  if (n === 0) {
    return (
      <div className="casa-carousel casa-carousel--empty">
        <img src={placeholder} alt={alt} />
      </div>
    );
  }

  if (n === 1) {
    return (
      <div className="casa-carousel casa-carousel--single">
        <img src={getFileUrl(urls[0]) || placeholder} alt={alt} onError={handleImgError} />
      </div>
    );
  }

  return (
    <div className="casa-carousel">
      <div className="casa-carousel-viewport">
        <div
          className="casa-carousel-track"
          style={{ transform: `translateX(-${idx * 100}%)` }}
        >
          {urls.map((url, i) => (
            <div key={`${url}-${i}`} className="casa-carousel-slide">
              <img
                src={getFileUrl(url) || placeholder}
                alt={`${alt} — ${i + 1}`}
                onError={handleImgError}
              />
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        className="casa-carousel-btn casa-carousel-btn--prev"
        onClick={() => goTo(idx - 1)}
        aria-label="Imagen anterior"
      >
        <FaChevronLeft />
      </button>
      <button
        type="button"
        className="casa-carousel-btn casa-carousel-btn--next"
        onClick={() => goTo(idx + 1)}
        aria-label="Imagen siguiente"
      >
        <FaChevronRight />
      </button>

      <div className="casa-carousel-dots">
        {urls.map((_, i) => (
          <button
            key={i}
            type="button"
            className={`casa-carousel-dot ${i === idx ? 'is-active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Ir a imagen ${i + 1}`}
            aria-current={i === idx}
          />
        ))}
      </div>

      <span className="casa-carousel-counter" aria-live="polite">
        {idx + 1} / {n}
      </span>
    </div>
  );
};

export default CasaEncuentroCarousel;
